import React from "react";
import { Card, Button, Row, Col, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faStamp,
  faSun,
  faTag,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

function ProjectList(props) {
  return (
    <div>
      {props.projects.length > 0 ? (
        <p style={{ marginLeft: "3%", fontSize: "small" }}>
          Found {props.projects.length} project(s)
        </p>
      ) : (
        ""
      )}
      <Row>
        {props.projects &&
          props.projects.map((project) => {
            return (
              <Col md={4} sm={6} xs={6} key={project.id}>
                <Card className="project-card shadow">
                  <div className="card-head">
                    <img
                      src={
                        project.image_url
                          ? project.image_url
                          : "https://energycenter.org/sites/default/files/articles/Blog%20Image%20-%20Community%20Solar.jpg"
                      }
                      height="150px"
                      width="400px"
                      style={{
                        borderRadius: "10px",
                        marginBottom: "0.5em",
                        maxWidth: "100%",
                      }}
                      className="project-card-image"
                    />
                    <br></br>
                    <b>
                      {project.name}{" "}
                      {project.status === "Active" ? (
                        <Badge bg="success">{project.status}</Badge>
                      ) : (
                        <Badge bg="warning">{project.status}</Badge>
                      )}
                    </b>
                    <hr></hr>
                  </div>

                  <Card.Body>
                    <p className="project-details">
                      {" "}
                      <FontAwesomeIcon icon={faLocationDot} /> {project.city},{" "}
                      {project.state}
                    </p>
                    {project.discount ? (
                      <p className="project-details">
                        {" "}
                        <FontAwesomeIcon icon={faTag} /> {project.discount}
                      </p>
                    ) : (
                      ""
                    )}
                    <p className="project-details">
                      {" "}
                      <FontAwesomeIcon icon={faStamp} />
                      <b> Min credit score: </b>
                      {project.min_credit_score}
                    </p>
                    <p className="project-details">
                      <span style={{ color: "gray" }}>
                        <FontAwesomeIcon icon={faSun}></FontAwesomeIcon>{" "}
                        Provided by{" "}
                      </span>
                      <b style={{ color: "#0dcaf0" }}>{project.provider}</b>
                    </p>

                    {project.description ? (
                      <p className="project-details">
                        <span style={{ color: "gray" }}>
                          <FontAwesomeIcon
                            icon={faInfoCircle}
                          ></FontAwesomeIcon>{" "}
                        </span>
                        <span style={{ fontSize: "small", color: "gray" }}>
                          {project.description}
                        </span>
                      </p>
                    ) : (
                      ""
                    )}

                    <a href={project.url} target="_blank" rel="noreferrer">
                      <Button className="btn-hover color-1">Details</Button>
                    </a>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
      </Row>
    </div>
  );
}

export default ProjectList;
